import type { PendingCharge } from '@pflegenavi/shared/api';
import { PendingChargeStatus } from '@pflegenavi/shared/api';

// Type for pending charges that only have the minimal required fields
interface MinimalPendingCharge {
  pending_charge_status: PendingChargeStatus;
  amount: number;
}

/**
 * Calculates the total amount of pending charges that are in "Upcoming" or "Pending" status
 * @param pendingCharges Array of pending charges
 * @returns Total amount in cents of upcoming and pending charges
 */
export const calculatePendingChargesAmount = (
  pendingCharges: MinimalPendingCharge[] | undefined
): number => {
  if (!pendingCharges || pendingCharges.length === 0) {
    return 0;
  }

  return pendingCharges
    .filter(
      (charge) =>
        charge.pending_charge_status === PendingChargeStatus.upcoming ||
        charge.pending_charge_status === PendingChargeStatus.pending
    )
    .reduce((sum, charge) => sum + charge.amount, 0);
};

/**
 * Checks if there are any pending charges in "Upcoming" or "Pending" status
 * @param pendingCharges Array of pending charges
 * @returns True if there are active pending charges
 */
export const hasActivePendingCharges = (
  pendingCharges: MinimalPendingCharge[] | undefined
): boolean => {
  if (!pendingCharges || pendingCharges.length === 0) {
    return false;
  }

  return pendingCharges.some(
    (charge) =>
      charge.pending_charge_status === PendingChargeStatus.upcoming ||
      charge.pending_charge_status === PendingChargeStatus.pending
  );
};
